import { createRoot } from 'react-dom/client';

// scroll bar
import 'simplebar-react/dist/simplebar.min.css';

// apex-chart
import 'assets/third-party/react-table.css';

import '@fontsource/public-sans/400.css';
import '@fontsource/public-sans/500.css';
import '@fontsource/public-sans/600.css';
import '@fontsource/public-sans/700.css';

// project imports
import App from './App';
import { ConfigProvider } from 'contexts/ConfigContext';
import { AuthProvider } from 'contexts/AuthContext';
import reportWebVitals from './reportWebVitals';

const appVersion = import.meta.env.VITE_APP_VERSION || '1.13.1';
const buildDate = import.meta.env.VITE_APP_BUILD_DATE || '';
console.info(`[yahen-dash] version=${appVersion}${buildDate ? ` buildDate=${buildDate}` : ''}`);

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <ConfigProvider>
    <AuthProvider>
      <App />
    </AuthProvider>
  </ConfigProvider>
);

reportWebVitals();
